import { hosts } from './hosts'

const initialExampleMap = {
  'rules': [
    [
      {
        'id': 'f025adec-b27a-4483-b3d3-fe112f168210',
        'text': 'The brown fox must eat the chicken',
        'examples': [
          {
            'id': '3beb79e4-1af7-4682-ba34-8e351b1663ce',
            'text': 'Example 2 the quick brown rabbit jumped over the carrot and it ran off with all the apples and bananas'
          },
          {
            'id': '1efaa3bd-3a80-4ab6-a7a1-cba430c903f7',
            'text': 'Example 2 the quick brown fox jumped over the hare and it ran off with all the apples and bananas'
          }
        ]
      },
      {
        'id': '65b8c659-072f-4f0d-af66-a54f661f77be',
        'text': 'All of the farmyard animals must watch out for the fox in case it attacks the chicken',
        'examples': [
        ]
      }
    ],
    [
      {
        'id': '0acbd18b-67fe-44e0-a713-b9bfa42840a9',
        'text': 'Every day the farmer needs to polish the cow',
        'examples': [
          {
            'id': 'c99669af-bdc6-49c2-b8d7-20dcd7e30d70',
            'text': 'A really long example. A really long example. A really long example. A really long example. A really long example. A really long example. A really long example. A really long example. A really long example. A really long example. A really long example. A really long example. A really long example. A really long example. A really long example. A really long example. '
          }
        ]
      }
    ],
    []
  ],
  'questions': [
    {
      id: '33de8ce0-3974-4141-8d3b-acea13400bfd',
      text: 'What happens if the farm doesn\'t milk the goat?'
    }
  ],
  'notes': {
    text: 'some notes'
  }
}

export default class FakeAdapter {
  async load () {
    return initialExampleMap
  }

  async save (state) {
  }

  async fetchSummary () {
    return '-'
  }

  async fetchIssueKey () {
    return '-'
  }

  async getCustomerIdentifier () {
    return 'fake'
  }

  getHost () {
    return hosts.FAKE
  }

  async loadInitialExampleMap () {
    return initialExampleMap
  }
}
